// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import Title from '../../_common/form/Title';
import Card from '../Card';

const Updated = ({ ...props }) => {
    
    return (
        <Card>
            <Title>Success</Title>
            Password has been updated, please open your app again to log in.
        </Card>
    );
}

export default Updated;